export const addressMutationSitecoreLabels = {
  HeadingContacts: { value: "Van wie wil je het adres wijzigen?" },
  HeadingCity: { value: "Woonplaats" },
  HeadingHasAdditionalAddressDetails: { value: "Aanvullende adresgegevens toevoegen?" },
  HeadingHouseNumber: { value: "Huisnummer" },
  HeadingHouseNumberAddition: { value: "Toevoeging" },
  HeadingLocation: { value: "Locatie" },
  HeadingPostcode: { value: "Postcode" },
  HeadingStartDate: { value: "Per wanneer geldt deze wijziging?" },
  HeadingStreet: { value: "Straat" },
  InfoCity: { value: "" },
  InfoHouseNumber: { value: "" },
  InfoHouseNumberAddition: { value: "" },
  InfoLocation: { value: "" },
  InfoPostcode: { value: "" },
  InfoStartDate: { value: "" },
  InfoStreet: { value: "" },
  PlaceholderCity: { value: "Woonplaats" },
  PlaceholderHouseNumber: { value: "Huisnummer" },
  PlaceholderHouseNumberAddition: { value: "Toevoeging" },
  PlaceholderLocation: { value: "Locatie" },
  PlaceholderPostcode: { value: "Postcode" },
  PlaceholderStartDate: { value: "Kies de ingangsdatum" },
  PlaceholderStreet: { value: "Straat" },
  TooltipCity: { value: "" },
  TooltipHasAdditionalAddressDetails: { value: "" },
  TooltipHouseNumber: { value: "" },
  TooltipHouseNumberAddition: { value: "" },
  TooltipLocation: { value: "" },
  TooltipPostcode: { value: "" },
  TooltipStartDate: { value: "" },
  TooltipStreet: { value: "" },
};
